import { estadoUi } from './catalogs/campos-modificables';
import type { ModificacionItem } from './services/modificaciones.service';

/**
 * Filtros de la tabla de resultados de Modificación de datos.
 *
 * Vive fuera de la pantalla (mismo criterio que `bajas-revision.ts`) para poder
 * testearlo sin montar el componente, y porque exportar una función desde un
 * archivo de componentes rompe el fast-refresh de Vite.
 */
export type FiltroModificacion =
  | 'todas'
  | 'aceptada'
  | 'rechazadas'
  | 'sin_cambio'
  | 'error_infra'
  // Los dos de después del despacho a Binary. `fallada` también cae dentro de
  // `rechazadas` —es algo que hay que corregir— pero tiene chip propio porque
  // el rechazo de Binary se arregla distinto que un error del archivo.
  | 'aplicada'
  | 'fallada';

/**
 * `rechazadas` se DERIVA del tono del catálogo en vez de ser una lista de
 * estados escrita a mano: si el server agrega un motivo de rechazo nuevo,
 * aparece solo en el filtro en lugar de quedar invisible para el usuario.
 */
export function filtrar(
  items: ModificacionItem[],
  filtro: FiltroModificacion,
): ModificacionItem[] {
  if (filtro === 'todas') return items;
  if (filtro === 'rechazadas') return items.filter((i) => estadoUi(i.estado).tono === 'error');
  return items.filter((i) => i.estado === filtro);
}

/**
 * Si una modificación se puede sacar del envío a mano.
 *
 * Solo las ACEPTADAS: las que tienen error no se despachan igual, así que
 * ofrecer una casilla para excluirlas sería un control que no hace nada. Y hace
 * falta el `id`, porque la exclusión viaja por id al server — el front nunca
 * manda los datos de la modificación.
 */
export function puedeExcluirse(item: ModificacionItem): boolean {
  return item.estado === 'aceptada' && !!item.id;
}
